// extracted by mini-css-extract-plugin
var _1 = "serviceCard-module__cardContainer___YJ6HC";
var _2 = "serviceCard-module__cardTextContainer___OTFVr";
export { _1 as "cardContainer", _2 as "cardTextContainer" }
